/* ScoopPath — collection filter engine (URL-driven, one mechanism for all filters + sort) */
(function () {
  var form = document.getElementById('vfilterform');
  if (!form) return;
  var collUrl = form.getAttribute('action') || location.pathname;
  var chipsBox = document.getElementById('vActiveChips');
  var priceNames = ['filter.v.price.gte', 'filter.v.price.lte'];

  function labelFor(name, value) {
    var el = form.querySelector('input[name="' + name + '"][value="' + (window.CSS && CSS.escape ? CSS.escape(value) : value) + '"]');
    if (el) {
      var lab = el.closest('label');
      var span = lab && lab.querySelector('span');
      if (span) return span.textContent.trim();
    }
    return value;
  }

  function currentParams() {
    return new URLSearchParams(location.search);
  }

  function buildQuery(overrides) {
    var p = new URLSearchParams();
    var sort = document.getElementById('vSortSelect');
    var sb = (overrides && overrides.sort_by) || (sort && sort.value) || currentParams().get('sort_by') || '';
    if (sb && sb !== 'manual' && sb !== 'best-selling' || sb === 'best-selling') { if (sb) p.set('sort_by', sb); }
    Array.prototype.forEach.call(form.querySelectorAll('input[type="checkbox"]:checked'), function (i) {
      p.append(i.name, i.value);
    });
    Array.prototype.forEach.call(form.querySelectorAll('input[type="number"]'), function (i) {
      var raw = (i.value || '').trim();
      if (raw === '') return;
      var n = parseFloat(raw.replace(',', '.'));
      if (isNaN(n) || n < 0) return;
      p.set(i.name, String(Math.round(n * 100) / 100));
    });
    var gte = p.get(priceNames[0]), lte = p.get(priceNames[1]);
    if (gte && lte && parseFloat(gte) > parseFloat(lte)) {
      p.set(priceNames[0], lte); p.set(priceNames[1], gte);
    }
    if (overrides) {
      Object.keys(overrides).forEach(function (k) {
        if (k === 'sort_by') return;
        if (overrides[k] === null) p.delete(k); else p.set(k, overrides[k]);
      });
    }
    return p.toString();
  }

  function go(overrides) {
    var qs = buildQuery(overrides);
    var target = collUrl + (qs ? '?' + qs : '');
    location.href = target;
  }

  // auto apply on any filter change
  form.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.name) return;
    if (t.name.indexOf('filter.') === 0) go();
  });
  Array.prototype.forEach.call(form.querySelectorAll('input[type="number"]'), function (i) {
    i.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); go(); } });
    i.addEventListener('blur', function () { if (i.value !== i.defaultValue) go(); });
  });

  // sort keeps filters
  var sortSel = document.getElementById('vSortSelect');
  if (sortSel) {
    sortSel.addEventListener('change', function () { go({ sort_by: sortSel.value }); });
  }

  // apply / clear buttons
  var applyBtn = document.getElementById('vApplyFilters');
  if (applyBtn) applyBtn.addEventListener('click', function (e) { e.preventDefault(); go(); });
  Array.prototype.forEach.call(document.querySelectorAll('[data-vclearall]'), function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); location.href = collUrl; });
  });

  // active filter chips
  if (chipsBox) {
    var p = currentParams();
    var chips = [];
    p.forEach(function (v, k) {
      if (k.indexOf('filter.p.') === 0 || k.indexOf('filter.v.availability') === 0) {
        chips.push({ key: k, val: v, label: labelFor(k, v), remove: k + '=' + v });
      }
    });
    var gte = p.get(priceNames[0]), lte = p.get(priceNames[1]);
    if (gte || lte) {
      chips.push({ key: 'price', val: (gte || 0) + '-' + (lte || ''), label: '$' + (gte || 0) + (lte ? ' – $' + lte : '+'), remove: 'price' });
    }
    if (chips.length) {
      var html = '<span class="vchipslabel">Active:</span>';
      chips.forEach(function (c) {
        html += '<a class="vactivechip" data-k="' + c.key + '" data-v="' + c.val + '" href="#">' + c.label + ' <b>&times;</b></a>';
      });
      html += '<a class="vclearall" data-vclearall href="#">Clear all</a>';
      chipsBox.innerHTML = html;
      chipsBox.hidden = false;
      Array.prototype.forEach.call(chipsBox.querySelectorAll('.vactivechip'), function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          var k = a.getAttribute('data-k');
          if (k === 'price') { go({ 'filter.v.price.gte': null, 'filter.v.price.lte': null }); return; }
          var copy = [];
          currentParams().forEach(function (v, kk) { if (kk !== k) copy.push([kk, v]); });
          var q = new URLSearchParams();
          copy.forEach(function (pair) { q.append(pair[0], pair[1]); });
          var t = collUrl + (q.toString() ? '?' + q.toString() : '');
          location.href = t;
        });
      });
      Array.prototype.forEach.call(chipsBox.querySelectorAll('[data-vclearall]'), function (a) {
        a.addEventListener('click', function (e) { e.preventDefault(); location.href = collUrl; });
      });
    } else { chipsBox.hidden = true; }
  }

  // brand search for long lists
  var brandDetails = form.querySelector('.vfg--brand');
  if (brandDetails) {
    var list = brandDetails.querySelector('.vflist');
    var count = list ? list.querySelectorAll('li').length : 0;
    if (count > 10) {
      var wrap = document.createElement('div');
      wrap.className = 'vbrandsearch';
      wrap.innerHTML = '<input type="search" placeholder="Search brands…" aria-label="Search brands">';
      brandDetails.insertBefore(wrap, list);
      wrap.querySelector('input').addEventListener('input', function (e) {
        var q = e.target.value.trim().toLowerCase();
        Array.prototype.forEach.call(list.querySelectorAll('li'), function (li) {
          li.style.display = !q || li.textContent.toLowerCase().indexOf(q) > -1 ? '' : 'none';
        });
      });
    }
  }

  // result count into apply button (mobile)
  var cnt = document.querySelector('.vccount');
  if (applyBtn && cnt) applyBtn.setAttribute('data-count', cnt.textContent.trim());
})();
